const INCIDENT_EXPORT_FIELDS = {
  FIRSTNAME: 'PI_FirstName',
  LASTNAME: 'PI_LastName',
  DATE_OF_BIRTH: 'PI_DateOfBirth',
  SEQUENCE_NUMBER: 'II_SequenceNumber',
  INCIDENT_DATE: 'II_IncidentDate',
};

export default INCIDENT_EXPORT_FIELDS;
